import { render, staticRenderFns } from "./temp-subjective.vue?vue&type=template&id=1b4479a6&scoped=true"
import script from "./temp-subjective.vue?vue&type=script&lang=js"
export * from "./temp-subjective.vue?vue&type=script&lang=js"
import style0 from "./temp-subjective.vue?vue&type=style&index=0&id=1b4479a6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4479a6",
  null
  
)

export default component.exports